import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.codex.detail');
import { OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-codex-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.codex.detail/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
  background: #f2f4f0;
  color: #17202a;
}

.studio-page {
  height: calc(100vh - 0px);
  min-height: 720px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.studio-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 20px;
  border-bottom: 1px solid #dfe4dc;
  background: #fff;
}

.header-left,
.header-actions,
.rfp-quick,
.rfp-link,
.section-head,
.chapter-head,
.job-top,
.job-detail-head,
.file-drop {
  display: flex;
  align-items: center;
}

.header-left {
  gap: 12px;
  min-width: 0;
}

.header-left h1 {
  overflow: hidden;
  max-width: 620px;
  margin: 2px 0 3px;
  color: #17202a;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-left p {
  margin: 0;
  color: #7b857f;
  font-size: 12px;
  font-weight: 700;
}

.kicker {
  color: #b28921;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

button {
  font: inherit;
}

.back-btn,
.icon-btn,
.primary-btn,
.secondary-btn,
.stage-btn,
.chapter-row,
.job-row,
.send-btn,
.attach-btn,
.clear-files,
.mini-run {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.16s ease;
}

.back-btn,
.icon-btn {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-color: #d8ded6;
  background: #fff;
  color: #5f6a63;
}

.primary-btn,
.secondary-btn {
  min-height: 38px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 820;
  white-space: nowrap;
}

.primary-btn {
  background: #10375c;
  color: #fff;
}

.secondary-btn {
  border-color: #d8ded6;
  background: #fff;
  color: #27313d;
}

.secondary-btn.sm {
  min-height: 30px;
  padding: 0 10px;
  font-size: 11px;
}

.primary-btn.sm {
  min-height: 30px;
  padding: 0 10px;
  font-size: 11px;
}

.download-menu {
  position: relative;
  display: inline-flex;
}

.download-trigger .fa-chevron-down {
  font-size: 10px;
}

.download-menu-panel {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 40;
  min-width: 210px;
  padding: 6px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 14px 30px rgba(20, 32, 44, 0.14);
}

.download-menu-panel button {
  width: 100%;
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #27313d;
  font-size: 12px;
  font-weight: 780;
  text-align: left;
  cursor: pointer;
}

.download-menu-panel button:hover {
  background: #f2f6f1;
}

.download-menu-panel i {
  width: 14px;
  color: #8a6b11;
  text-align: center;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.studio-shell {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 440px;
  gap: 12px;
  padding: 12px;
  overflow: hidden;
}

.preview-pane,
.codex-pane {
  min-height: 0;
  border: 1px solid #dfe4dc;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.preview-pane {
  display: flex;
  flex-direction: column;
}

.design-gate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 72px;
  padding: 10px 12px;
  border-bottom: 1px solid #e8ece4;
  background: #fbfcf8;
}

.design-gate.approved {
  background: #f4faf7;
}

.design-gate.empty {
  background: #fffdf6;
}

.design-gate-copy {
  min-width: 0;
}

.design-gate-copy b {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #17202a;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.design-gate-copy p {
  display: -webkit-box;
  overflow: hidden;
  margin: 3px 0 0;
  color: #657069;
  font-size: 12px;
  line-height: 1.45;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.design-gate-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.starter-preview {
  flex: 1;
  min-height: 0;
  display: grid;
  place-items: center;
  padding: 36px;
  background: #f7f9fb;
}

.starter-card {
  width: min(720px, 100%);
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(240px, 0.8fr);
  gap: 22px;
  padding: 28px;
  border: 1px solid #dfe6ee;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(20, 32, 44, 0.08);
}

.starter-main {
  min-width: 0;
}

.starter-main h2 {
  margin: 6px 0 8px;
  color: #17202a;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 900;
}

.starter-main p {
  margin: 0;
  color: #4f5b55;
  font-size: 13px;
  line-height: 1.65;
}

.starter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}

.starter-status {
  display: grid;
  gap: 8px;
  align-content: start;
}

.starter-status-row {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #e3e8df;
  border-radius: 8px;
  background: #fbfcf8;
}

.starter-status-row.ready {
  border-color: #bfd1c2;
  background: #f4faf7;
}

.starter-status-row > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #eef4fb;
  color: #10375c;
}

.starter-status-row.ready > i {
  background: #e9f7f2;
  color: #0f6b57;
}

.starter-status-row b,
.starter-status-row span {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.starter-status-row b {
  color: #17202a;
  font-size: 12px;
  font-weight: 850;
}

.starter-status-row span {
  margin-top: 2px;
  color: #657069;
  font-size: 11px;
}

.preview-frame {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: 0;
  background: #e8ecef;
}

.codex-pane {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  overflow-y: auto;
  background: #fbfcf8;
}

.pane-section {
  flex: 0 0 auto;
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e0e5dc;
  border-radius: 8px;
  background: #fff;
}

.status-section {
  gap: 8px;
}

.rfp-quick {
  min-height: 32px;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #e8ece4;
  border-radius: 8px;
  background: #fff;
}

.rfp-label {
  flex: 0 0 auto;
  color: #b28921;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
}

.rfp-links {
  min-width: 0;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 5px 8px;
}

.rfp-link {
  min-width: 0;
  max-width: 100%;
  gap: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #10375c;
  font-size: 11px;
  font-weight: 850;
  cursor: pointer;
}

.rfp-link i {
  flex: 0 0 auto;
  color: #0f6b57;
  font-size: 11px;
}

.rfp-link span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rfp-link:hover span {
  text-decoration: underline;
}

.rfp-empty {
  min-width: 0;
  color: #8a948f;
  font-size: 11px;
  font-weight: 750;
}

.job-harness-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.job-harness-chips span {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  max-width: 100%;
  padding: 0 8px;
  border: 1px solid #d8ded6;
  border-radius: 999px;
  background: #fff;
  color: #4f5b55;
  font-size: 10px;
  font-weight: 820;
}

.progress-section {
  min-width: 0;
  overflow: hidden;
  border-color: #c7d7ef;
  background: #f6f9ff;
}

.progress-head,
.progress-meta,
.progress-log {
  display: flex;
  align-items: center;
}

.progress-head {
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.progress-head > div {
  min-width: 0;
}

.progress-head h2 {
  overflow: hidden;
  margin: 2px 0 0;
  color: #10375c;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.progress-head strong {
  flex: 0 0 auto;
  color: #10375c;
  font-size: 22px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.progress-bar {
  width: 100%;
  max-width: 100%;
  height: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: #dfeaf8;
}

.progress-fill {
  height: 100%;
  min-width: 6px;
  max-width: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #10375c, #2f7d68, #b28921);
  transition: width 0.35s ease;
}

.progress-meta {
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  color: #4f5b55;
  font-size: 12px;
  font-weight: 800;
}

.progress-meta span {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.progress-meta i {
  color: #10375c;
}

.progress-meta em {
  flex: 0 0 auto;
  color: #7b857f;
  font-style: normal;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.progress-job {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  padding: 9px 10px;
  border: 1px solid #dbe6f4;
  border-radius: 8px;
  background: #fff;
}

.progress-job b {
  display: -webkit-box;
  overflow: hidden;
  color: #27313d;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
  overflow-wrap: anywhere;
  word-break: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.progress-logs {
  display: grid;
  gap: 5px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.progress-log {
  gap: 7px;
  min-width: 0;
  max-width: 100%;
  color: #657069;
  font-size: 11px;
  line-height: 1.35;
}

.progress-log i {
  color: #b28921;
  font-size: 5px;
}

.progress-log span {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section-head {
  justify-content: space-between;
  gap: 12px;
}

.section-head h2 {
  margin: 2px 0 0;
  color: #17202a;
  font-size: 14px;
  font-weight: 850;
}

.doc-count,
.step-hint {
  color: #7b857f;
  font-size: 11px;
  font-weight: 750;
}

.doc-list,
.chapter-list {
  display: grid;
  gap: 7px;
}

.doc-row {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 8px;
  border: 1px solid #edf0ea;
  border-radius: 8px;
  background: #fbfcf8;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.doc-row:hover {
  border-color: #cfd8cb;
  background: #f6f9f3;
}

.doc-row i {
  color: #0f6b57;
  margin-top: 2px;
}

.doc-row b,
.doc-row span {
  display: block;
}

.doc-row b {
  overflow: hidden;
  color: #17202a;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-row span {
  margin-top: 2px;
  color: #7b857f;
  font-size: 11px;
}

.doc-empty,
.job-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  color: #7b857f;
  font-size: 12px;
}

.stage-list {
  display: grid;
  gap: 7px;
}

.stage-btn {
  width: 100%;
  min-height: 58px;
  display: grid;
  grid-template-columns: 32px 30px minmax(0, 1fr) auto;
  justify-content: stretch;
  padding: 8px 10px;
  border-color: #dfe4dc;
  background: #fff;
  color: #4f5b55;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
}

.stage-btn.active {
  border-color: #10375c;
  background: #eef4fb;
  color: #10375c;
}

.stage-btn.done:not(.active) {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.stage-btn.approved:not(.active) {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.stage-btn.locked {
  border-color: #e4e8df;
  background: #fafbf8;
  color: #8a948f;
}

.stage-index {
  color: #b28921;
  font-size: 10px;
  line-height: 1;
  font-weight: 900;
}

.stage-icon {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #eef4f1;
  color: #68736c;
}

.stage-btn.active .stage-icon {
  background: #dfeaf8;
  color: #10375c;
}

.stage-btn.approved .stage-icon,
.stage-btn.done .stage-icon {
  background: #e9f7f2;
  color: #0f6b57;
}

.stage-btn.locked .stage-icon {
  background: #eef1eb;
  color: #9aa39e;
}

.stage-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.stage-copy b,
.stage-copy small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stage-copy b {
  color: #17202a;
  font-size: 12px;
  line-height: 1.2;
}

.stage-copy small {
  color: #7b857f;
  font-size: 10px;
  line-height: 1.25;
  font-weight: 750;
}

.stage-btn em {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 999px;
  background: #f2f5f0;
  color: #68736c;
  font-size: 10px;
  line-height: 1;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.stage-btn.active em {
  background: #dfeaf8;
  color: #10375c;
}

.stage-btn.done em,
.stage-btn.approved em {
  background: #dcfce7;
  color: #166534;
}

.stage-approval-panel {
  display: grid;
  gap: 8px;
}

.stage-approval-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #d7e3f2;
  border-radius: 8px;
  background: #f6f9ff;
}

.stage-approval-copy {
  min-width: 0;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
}

.stage-approval-copy > i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #e7eef8;
  color: #10375c;
}

.stage-approval-copy b,
.stage-approval-copy span {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stage-approval-copy b {
  color: #17202a;
  font-size: 12px;
  font-weight: 850;
}

.stage-approval-copy span {
  margin-top: 2px;
  color: #657069;
  font-size: 11px;
}

.workflow-note {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #efe1b8;
  border-radius: 8px;
  background: #fffaf0;
  color: #806016;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 750;
}

.chapter-box {
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid #edf0ea;
  border-radius: 8px;
  background: #fbfcf8;
}

.chapter-head {
  justify-content: space-between;
  gap: 10px;
  color: #17202a;
  font-size: 12px;
}

.chapter-head span,
.chapter-summary {
  color: #7b857f;
}

.chapter-summary {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-width: 0;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.chapter-summary .total-pages {
  padding: 3px 6px;
  border-radius: 999px;
  background: #eef4fb;
  color: #10375c;
  font-size: 10px;
  line-height: 1;
  font-weight: 900;
}

.chapter-row {
  width: 100%;
  min-height: 40px;
  justify-content: flex-start;
  padding: 7px;
  border-color: #e3e8df;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.chapter-row.active {
  border-color: #10375c;
}

.chapter-row .no {
  width: 24px;
  color: #b28921;
  font-weight: 900;
}

.chapter-row b {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  color: #17202a;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chapter-row .pages {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 999px;
  background: #eef7f4;
  color: #0f6b57;
  font-size: 10px;
  line-height: 1;
  font-weight: 850;
  white-space: nowrap;
}

.chapter-row em {
  color: #7b857f;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.validation-alert {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #f2c7c7;
  border-radius: 8px;
  background: #fff5f5;
  color: #7f1d1d;
  font-size: 11px;
  line-height: 1.45;
}

.validation-alert i {
  margin-top: 2px;
  color: #b91c1c;
}

.validation-alert b,
.validation-alert span {
  display: block;
}

.validation-alert b {
  font-size: 12px;
  font-weight: 850;
}

.validation-alert span {
  margin-top: 2px;
  color: #8f2c2c;
}

.validation-alert ul {
  display: grid;
  gap: 2px;
  margin: 6px 0 0;
  padding-left: 15px;
}

.mini-run {
  width: 28px;
  height: 28px;
  border-color: #d8ded6;
  background: #fff;
  color: #10375c;
}

.asset-section {
  gap: 10px;
}

.asset-section.collapsed {
  gap: 8px;
}

.asset-section-head {
  align-items: flex-start;
}

.asset-toggle {
  min-width: 0;
  max-width: 220px;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  padding: 0 9px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  background: #fff;
  color: #4f5b55;
  font-size: 11px;
  font-weight: 820;
  cursor: pointer;
}

.asset-toggle span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-toggle i {
  flex: 0 0 auto;
  color: #7b857f;
  font-size: 10px;
}

.asset-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #edf0ea;
  border-radius: 8px;
  background: #fbfcf8;
  color: #657069;
  font-size: 11px;
  line-height: 1.4;
}

.asset-compact i {
  color: #0f6b57;
}

.asset-panel-body {
  display: grid;
  gap: 10px;
}

.asset-upload-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.asset-upload-card {
  min-width: 0;
  display: grid;
  gap: 5px;
  padding: 10px;
  border: 1px dashed #bfd1c2;
  border-radius: 8px;
  background: #f8fbf7;
  color: #27313d;
  cursor: pointer;
  transition: 0.16s ease;
}

.asset-upload-card:hover {
  border-color: #2f7d68;
  background: #f2faf6;
}

.asset-upload-card.uploading {
  opacity: 0.62;
  pointer-events: none;
}

.asset-upload-card input {
  display: none;
}

.asset-upload-card > i {
  color: #0f6b57;
  font-size: 15px;
}

.asset-upload-card b {
  overflow: hidden;
  color: #17202a;
  font-size: 12px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-upload-card span {
  display: -webkit-box;
  overflow: hidden;
  color: #657069;
  font-size: 10px;
  line-height: 1.35;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.asset-error {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 9px;
  border: 1px solid #f1b5ad;
  border-radius: 8px;
  background: #fff4f2;
  color: #a0342b;
  font-size: 11px;
  line-height: 1.4;
}

.asset-library-loading,
.asset-library-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  color: #7b857f;
  font-size: 12px;
}

.asset-library-groups,
.asset-library-group,
.asset-mini-list {
  display: grid;
  gap: 8px;
}

.asset-library-group {
  padding: 8px;
  border: 1px solid #edf0ea;
  border-radius: 8px;
  background: #fbfcf8;
}

.asset-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #4f5b55;
  font-size: 11px;
  font-weight: 850;
}

.asset-group-head span {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-group-head i {
  color: #b28921;
}

.asset-group-head em {
  flex: 0 0 auto;
  color: #7b857f;
  font-style: normal;
  font-size: 10px;
}

.asset-mini-list {
  overflow: visible;
}

.asset-mini-row {
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) 20px;
  align-items: center;
  gap: 8px;
  padding: 7px;
  border: 1px solid #e3e8df;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.asset-mini-row:hover {
  border-color: #cfd8cb;
}

.asset-mini-row.selected {
  border-color: #10375c;
  background: #eef4fb;
  box-shadow: inset 3px 0 0 #10375c;
}

.asset-mini-row > i {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: #eef7f4;
  color: #0f6b57;
  font-size: 12px;
}

.asset-mini-row div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.asset-mini-row b,
.asset-mini-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-mini-row b {
  color: #17202a;
  font-size: 12px;
  font-weight: 820;
}

.asset-mini-row span {
  color: #7b857f;
  font-size: 10px;
}

.asset-mini-row strong {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #10375c;
  color: #fff;
  font-size: 9px;
}

.asset-actions-row {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.chat-section {
  gap: 9px;
}

.action-hint {
  margin: -4px 0 0;
  color: #657069;
  font-size: 12px;
  line-height: 1.45;
}

.selected-page-banner {
  background: #fef3c7;
  border-left: 4px solid #c89b3c;
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.selected-page-banner .label {
  color: #92400e;
  font-weight: 600;
}
.selected-page-banner .page-info {
  color: #0d3b7d;
  flex: 1;
}
.selected-page-banner .clear {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 16px;
}

.chat-input {
  width: 100%;
  min-height: 108px;
  resize: vertical;
  padding: 11px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  color: #17202a;
  font: inherit;
  font-size: 13px;
  line-height: 1.55;
  outline: none;
}

.chat-input:focus {
  border-color: #10375c;
}

.file-drop {
  justify-content: space-between;
  gap: 10px;
}

.attach-btn,
.clear-files {
  min-height: 34px;
  padding: 0 11px;
  border-color: #d8ded6;
  background: #fff;
  color: #4f5b55;
  font-size: 12px;
  font-weight: 800;
}

.attach-btn input {
  display: none;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #dfe4dc;
  border-radius: 999px;
  background: #fbfcf8;
  color: #4f5b55;
  font-size: 11px;
  font-weight: 750;
}

.file-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-chip button {
  border: 0;
  background: transparent;
  color: #7b857f;
  cursor: pointer;
}

.send-btn {
  width: 100%;
  min-height: 42px;
  border-color: #10375c;
  background: #10375c;
  color: #fff;
  font-weight: 850;
}

.error-box {
  display: flex;
  gap: 8px;
  padding: 10px;
  border: 1px solid #f1b5ad;
  border-radius: 8px;
  background: #fff4f2;
  color: #a0342b;
  font-size: 12px;
}

.info-box {
  display: flex;
  gap: 8px;
  padding: 10px;
  border: 1px solid #bfd1c2;
  border-radius: 8px;
  background: #f8fbf7;
  color: #27313d;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.info-box i {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #0f6b57;
}

.history-section {
  min-height: 230px;
}

.history-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.history-stat {
  display: grid;
  gap: 3px;
  min-width: 0;
  padding: 8px 9px;
  border: 1px solid #dde5dc;
  border-radius: 8px;
  background: #fbfcf8;
}

.history-stat span {
  color: #7a857f;
  font-size: 10px;
  font-weight: 800;
}

.history-stat b {
  color: #17202a;
  font-size: 15px;
}

.history-list {
  display: grid;
  gap: 8px;
}

.history-row {
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 9px;
  align-items: start;
  position: relative;
  padding: 10px 10px 12px;
  border: 1px solid #e0e5dc;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-align: left;
  overflow: hidden;
}

.history-row:not(:disabled) {
  cursor: pointer;
}

.history-row:disabled {
  cursor: default;
  opacity: 1;
}

.history-row.active {
  border-color: #10375c;
  box-shadow: inset 3px 0 0 #10375c;
}

.history-row.running {
  border-color: #c7d7ef;
  background: #f5f9ff;
}

.history-icon {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #eef4f1;
  color: #68736c;
  font-size: 12px;
}

.history-icon.is-progress {
  background: #eaf3ff;
  color: #1d5b9f;
}

.history-icon.is-done {
  background: #e9f7f2;
  color: #0f6b57;
}

.history-icon.is-error {
  background: #fff0ef;
  color: #b42318;
}

.history-main {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.history-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.history-title b {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #17202a;
  font-size: 12px;
}

.history-main p {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #4f5b55;
  font-size: 11px;
  line-height: 1.45;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.history-main small {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: #8a948f;
  font-size: 10px;
  line-height: 1.4;
}

.history-main small em {
  color: #66736c;
  font-style: normal;
}

.history-progress {
  position: absolute;
  left: 49px;
  right: 10px;
  bottom: 6px;
  height: 3px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef2ec;
}

.history-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #10375c;
}

.job-row {
  width: 100%;
  display: grid;
  gap: 6px;
  justify-items: stretch;
  padding: 10px;
  border-color: #e0e5dc;
  background: #fff;
  text-align: left;
}

.job-row.active {
  border-color: #10375c;
}

.job-row.running {
  border-color: #c7d7ef;
  background: #f5f9ff;
}

.job-top {
  justify-content: space-between;
  gap: 8px;
}

.job-top b {
  color: #17202a;
  font-size: 12px;
}

.job-row p {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #4f5b55;
  font-size: 12px;
  line-height: 1.45;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.job-row small {
  color: #8a948f;
  font-size: 10px;
}

em.is-progress {
  color: #1d5b9f;
}

em.is-done {
  color: #0f6b57;
}

em.is-error {
  color: #b42318;
}

.job-detail {
  display: grid;
  gap: 8px;
  margin-top: 4px;
  padding: 10px;
  border: 1px solid #e0e5dc;
  border-radius: 8px;
  background: #fbfcf8;
}

.job-detail-head {
  justify-content: space-between;
  gap: 8px;
}

.job-run-data {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.job-run-data span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  padding: 0 8px;
  border: 1px solid #dfe7de;
  border-radius: 999px;
  background: #fff;
  color: #4f5b55;
  font-size: 10px;
  font-weight: 780;
}

.job-log-list {
  display: grid;
  gap: 6px;
}

.job-log-line {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr);
  gap: 7px;
  padding: 7px 8px;
  border: 1px solid #e3e9e0;
  border-radius: 8px;
  background: #fff;
}

.job-log-line > i {
  margin-top: 4px;
  color: #87928c;
  font-size: 5px;
}

.job-log-line.done > i,
.job-log-line.message > i {
  color: #0f6b57;
}

.job-log-line.error > i,
.job-log-line.warn > i {
  color: #b42318;
}

.job-log-line div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.job-log-line b {
  color: #1f2a36;
  font-size: 10px;
}

.job-log-line span {
  color: #4f5b55;
  font-size: 11px;
  line-height: 1.45;
  word-break: break-word;
}

.job-harness {
  display: grid;
  gap: 6px;
  padding: 9px;
  border: 1px solid #dbe6f4;
  border-radius: 8px;
  background: #f6f9ff;
}

.job-harness b {
  color: #10375c;
  font-size: 12px;
}

.job-harness > span {
  color: #4f5b55;
  font-size: 11px;
  line-height: 1.45;
}

.job-harness-chips span {
  border-color: #c7d7ef;
  background: #fff;
  color: #10375c;
}

.job-detail pre {
  max-height: 260px;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  color: #27313d;
  font-size: 11px;
  line-height: 1.55;
}

.loading-state {
  min-height: 60vh;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  color: #657069;
}

.spinner {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 3px solid #e4e9e2;
  border-top-color: #10375c;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1180px) {
  .studio-page {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
  .studio-shell {
    grid-template-columns: 1fr;
    overflow: visible;
  }
  .preview-pane {
    min-height: 640px;
  }
  .starter-preview {
    padding: 22px;
  }
  .starter-card {
    grid-template-columns: 1fr;
  }
  .codex-pane {
    max-height: none;
  }
}`],
})
export class PageCodexDetailComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public notice_no: string = '';
    public item: any = null;
    public docs: any[] = [];
    public state: any = {};
    public jobs: any[] = [];
    public history: any[] = [];
    public selectedJobId: string = '';
    public loading: boolean = true;
    public previewUrl: SafeResourceUrl | string = '';
    public previewKind: 'design' | 'toc' | 'chapter' | 'empty' = 'empty';

    public codexLoading: boolean = false;
    public codexInput: string = '';
    public codexStage: string = 'toc_design';
    public codexModel: string = '';
    public codexFiles: File[] = [];
    public selectedChapterId: string = '';
    public selectedPage: any = null;
    public pollTimer: any = null;
    public progressTimer: any = null;
    public pollingJobId: string = '';
    public errorMessage: string = '';
    public approvingStage: 'design' | 'toc' | '' = '';
    public pdfDownloading: boolean = false;
    public downloadMenuOpen: boolean = false;
    public downloadingFormat: 'pdf' | 'html' | 'css' | 'zip' | '' = '';
    public assetLibLoading: boolean = false;
    public assetUploading: boolean = false;
    public assetUploadError: string = '';
    public assetLibCompanies: any[] = [];
    public assetLibPersonnel: any[] = [];
    public selectedLibCompanyId: string = '';
    public selectedLibPersonnelIds: any = {};
    public assetPanelOpen: boolean = false;

    public readonly assetAcceptedExtensions: string = '.md,.pdf,.txt,.doc,.docx,.hwp,.hwpx,.png,.jpg,.jpeg,.webp';
    public readonly assetUploadSlots: any[] = [
        {
            id: 'company',
            assetType: 'companies',
            title: '회사 정보',
            description: '회사소개서, 일반현황, 조직/역량 자료',
            icon: 'fas fa-building',
            cta: '회사 자료 업로드',
        },
        {
            id: 'personnel',
            assetType: 'personnel',
            title: '투입 인력',
            description: '사업 투입 인력, PM/수행조직, 이력 자료',
            icon: 'fas fa-user-tie',
            cta: '인력 자료 업로드',
        },
    ];

    public readonly stages: any[] = [
        { id: 'toc_design', label: '목차 설계', icon: 'fas fa-list-ol', hint: 'RFP 작성요령과 평가항목 정리', actionLabel: '목차 설계 시작' },
        { id: 'chapter_generate', label: '챕터별 생성', icon: 'fas fa-layer-group', hint: '확정 목차 기준으로 자유 생성', actionLabel: '선택 챕터 생성' },
        { id: 'revision', label: '수정 요청', icon: 'fas fa-pen-to-square', hint: '현재 산출물 보정', actionLabel: '수정 요청 보내기' },
    ];

    private pageSelectedMessageHandler = async (event: MessageEvent) => {
        if (!event.data || event.data.type !== 'page-selected') return;
        this.selectedPage = {
            pageId: event.data.pageId || '',
            pageNo: event.data.pageNo || '',
            chapterId: event.data.chapterId || '',
            pageKind: event.data.pageKind || '',
        };
        await this.service.render();
    };

    public get visibleStages(): any[] {
        return this.stages;
    }

    public get rfpDocs(): any[] {
        return (this.docs || []).filter((doc: any) => this.isRfpDocument(doc));
    }

    public get attachmentDocs(): any[] {
        return (this.docs || []).filter((doc: any) => !this.isRfpDocument(doc));
    }

    private isRfpDocument(doc: any): boolean {
        const rfpValue = String(doc?.is_rfp ?? '').toLowerCase();
        if (doc?.is_rfp === true || doc?.is_rfp === 1 || rfpValue === 'true') return true;

        const type = String(doc?.doc_type || '').trim().toLowerCase();
        if (['rfp', '제안요청서', '제안안내서', '과업지시서', '과업내용서'].includes(type)) return true;

        const fileName = String(doc?.file_name || '').toLowerCase();
        return /rfp|제안요청|제안안내|과업지시|과업내용/.test(fileName);
    }

    public async ngOnInit() {
        window.addEventListener('message', this.pageSelectedMessageHandler);
        await this.service.init();
        this.notice_no = this.resolveNoticeNo();
        if (!this.notice_no) {
            this.errorMessage = '자료함 ID를 찾지 못했습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        await this.load();
        await this.service.render();
    }

    public ngOnDestroy() {
        window.removeEventListener('message', this.pageSelectedMessageHandler);
        this.stopPolling();
        this.stopProgressTimer();
    }

    private resolveNoticeNo(): string {
        const routeId = String((typeof WizRoute !== 'undefined' && WizRoute?.segment?.id) || '').trim();
        if (routeId && routeId !== 'undefined' && routeId !== 'null') {
            return decodeURIComponent(routeId);
        }
        const parts = String(window.location.pathname || '').split('/').filter(Boolean);
        const codexIndex = parts.indexOf('codex');
        const pathId = codexIndex >= 0 ? parts[codexIndex + 1] : '';
        return pathId ? decodeURIComponent(pathId) : '';
    }

    public async load(render: boolean = true) {
        if (!this.notice_no) this.notice_no = this.resolveNoticeNo();
        if (!this.notice_no) {
            this.errorMessage = '자료함 ID를 찾지 못했습니다.';
            this.loading = false;
            if (render) await this.service.render();
            return;
        }
        this.loading = true;
        if (render) await this.service.render();
        try {
            const res = await wiz.call('load_studio', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.item = res.data.item;
                this.docs = res.data.docs || [];
                this.state = res.data.state || {};
                this.jobs = res.data.jobs || [];
                this.history = res.data.history || this.buildHistoryRows();
                this.hydrateAssetLibrary(res.data.asset_library || {});
                this.syncCodexStageFromState(false);
                this.previewKind = this.state.preview_kind || 'empty';
                if (!this.selectedJobId && this.jobs.length > 0) this.selectedJobId = this.jobs[0].id;
                const active = this.activeJob;
                if (active) this.startPolling(active.id);
                this.refreshPreviewUrl();
            } else {
                this.errorMessage = res.data?.message || '자료함을 불러오지 못했습니다.';
            }
        } catch (e: any) {
            this.errorMessage = e?.message || '자료함을 불러오지 못했습니다.';
        }
        this.loading = false;
        if (render) await this.service.render();
    }

    private asArray(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (value === null || value === undefined || value === '') return [];
        if (typeof value === 'object') return Object.values(value);
        return [];
    }

    private normalizeMetadata(metadata: any): any {
        if (!metadata) return {};
        if (typeof metadata === 'object' && !Array.isArray(metadata)) return { ...metadata };
        if (typeof metadata === 'string') {
            try {
                const parsed = JSON.parse(metadata);
                return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch { }
        }
        return {};
    }

    private normalizeAssetList(value: any): any[] {
        return this.asArray(value)
            .filter((asset: any) => asset && typeof asset === 'object')
            .map((asset: any) => ({
                ...asset,
                metadata: this.normalizeMetadata(asset.metadata),
                files: this.asArray(asset.files),
            }));
    }

    private normalizeIdList(value: any): string[] {
        if (Array.isArray(value)) return value.map((id: any) => String(id)).filter(Boolean);
        if (value && typeof value === 'object') return Object.keys(value).filter((key: string) => !!value[key]);
        if (value === null || value === undefined || value === '') return [];
        return [String(value)];
    }

    private normalizeAssetSelection(selection: any): any {
        const data = selection && typeof selection === 'object' && !Array.isArray(selection) ? selection : {};
        return {
            company_id: data.company_id ? String(data.company_id) : '',
            personnel_ids: this.normalizeIdList(data.personnel_ids),
        };
    }

    private hydrateAssetLibrary(payload: any) {
        const data = payload || {};
        this.assetLibCompanies = this.normalizeAssetList(data.companies);
        this.assetLibPersonnel = this.normalizeAssetList(data.personnel);
        const selection = this.normalizeAssetSelection(data.selection || {});
        this.selectedLibCompanyId = selection.company_id || data.self_company_id || '';
        this.selectedLibPersonnelIds = {};
        for (const id of selection.personnel_ids || []) {
            this.selectedLibPersonnelIds[String(id)] = true;
        }
        this.assetLibLoading = false;
    }

    public async refreshAssetLibrary(render: boolean = true) {
        this.assetLibLoading = true;
        if (render) await this.service.render();
        try {
            const res = await wiz.call('load_asset_library', { notice_no: this.notice_no });
            if (res.code === 200) this.hydrateAssetLibrary(res.data || {});
        } catch (e: any) {
            this.assetUploadError = e?.message || '자산 라이브러리를 불러오지 못했습니다.';
        }
        this.assetLibLoading = false;
        if (render) await this.service.render();
    }

    public get selectedAssetTotalCount(): number {
        return (this.selectedLibCompanyId ? 1 : 0) + this.selectedPersonnelCount;
    }

    public get selectedPersonnelCount(): number {
        return Object.keys(this.selectedLibPersonnelIds || {}).filter((key: string) => !!this.selectedLibPersonnelIds[key]).length;
    }

    public get assetSelectionSummary(): string {
        const companyCount = this.selectedLibCompanyId ? 1 : 0;
        const personnelCount = this.selectedPersonnelCount;
        if (!companyCount && !personnelCount) return '선택된 회사·인력 자료 없음';
        return `회사 ${companyCount}개 · 인력 ${personnelCount}명 선택`;
    }

    public get assetLibrarySections(): any[] {
        return [
            {
                id: 'company',
                title: '회사 정보',
                icon: 'fas fa-building',
                items: this.assetLibCompanies,
                selectedCount: this.selectedLibCompanyId ? 1 : 0,
            },
            {
                id: 'personnel',
                title: '투입 인력',
                icon: 'fas fa-user-tie',
                items: this.assetLibPersonnel,
                selectedCount: this.selectedPersonnelCount,
            },
        ].filter((section: any) => section.items.length > 0);
    }

    public getAssetSubtitle(asset: any, kind: string): string {
        const meta = asset?.metadata || {};
        if (kind === 'company') {
            const companyType = meta.company_type === 'self' ? '자사' : (meta.company_type === 'consortium' ? '컨소시엄' : '회사');
            const detail = [meta.founded, meta.employees ? `${meta.employees}명` : ''].filter(Boolean).join(' · ');
            return detail ? `${companyType} · ${detail}` : companyType;
        }
        const detail = [meta.company, meta.team, meta.position || meta.role_category].filter(Boolean).join(' · ');
        return detail || (asset?.has_resume ? '첨부 이력 있음' : '인력 자료');
    }

    public isAssetSelected(kind: string, asset: any): boolean {
        const id = String(asset?.id || '');
        if (!id) return false;
        if (kind === 'company') return this.selectedLibCompanyId === id;
        return !!this.selectedLibPersonnelIds[id];
    }

    public async toggleAssetSelection(kind: string, asset: any) {
        const id = String(asset?.id || '');
        if (!id) return;
        if (kind === 'company') {
            this.selectedLibCompanyId = this.selectedLibCompanyId === id ? '' : id;
        } else {
            this.selectedLibPersonnelIds = {
                ...this.selectedLibPersonnelIds,
                [id]: !this.selectedLibPersonnelIds[id],
            };
        }
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleAssetPanel() {
        this.assetPanelOpen = !this.assetPanelOpen;
        await this.service.render();
    }

    public buildLibAssetSelection(): any {
        return {
            company_id: this.selectedLibCompanyId || '',
            consortium_ids: [],
            personnel_ids: Object.keys(this.selectedLibPersonnelIds || {}).filter((key: string) => !!this.selectedLibPersonnelIds[key]),
            project_ids: [],
            image_ids: [],
            general_status_ids: [],
        };
    }

    private async saveAssetSelection() {
        try {
            const res = await wiz.call('save_asset_selection', {
                notice_no: this.notice_no,
                asset_selection: JSON.stringify(this.buildLibAssetSelection()),
            });
            if (res.code === 200 && res.data?.selection) {
                const selection = this.normalizeAssetSelection(res.data.selection);
                this.selectedLibCompanyId = selection.company_id;
                this.selectedLibPersonnelIds = {};
                for (const id of selection.personnel_ids || []) this.selectedLibPersonnelIds[String(id)] = true;
            }
        } catch (e: any) {
            this.assetUploadError = e?.message || '자산 선택을 저장하지 못했습니다.';
        }
    }

    public async onAssetUploadFileChange(slot: any, event: any) {
        const files: File[] = Array.from(event?.target?.files || []);
        if (event?.target) event.target.value = '';
        if (!files.length) return;
        await this.uploadLibraryAsset(slot, files);
    }

    public async uploadLibraryAsset(slot: any, files: File[]) {
        if (this.assetUploading || !slot || !files.length) return;
        this.assetPanelOpen = true;
        this.assetUploading = true;
        this.assetUploadError = '';
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('notice_no', this.notice_no);
            formData.append('asset_kind', slot.id);
            formData.append('asset_type', slot.assetType);
            formData.append('name', files.length === 1 ? files[0].name.replace(/\.[^.]+$/, '') : slot.title);
            formData.append('description', slot.description || '');
            for (const file of files) formData.append('file', file);

            const response = await fetch(wiz.url('upload_library_asset'), {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const rawText = await response.text();
            let result: any = null;
            try {
                result = rawText ? JSON.parse(rawText) : null;
            } catch { }
            if (result?.code !== 200) {
                throw new Error(result?.data?.message || result?.message || this.extractErrorMessage(rawText) || '자산 업로드에 실패했습니다.');
            }
            this.hydrateAssetLibrary(result.data?.asset_library || {});
        } catch (e: any) {
            this.assetUploadError = e?.message || '자산 업로드에 실패했습니다.';
        }

        this.assetUploading = false;
        await this.service.render();
    }

    public openAssetLibrary() {
        window.open('/library', '_blank', 'noopener');
    }

    public goBack() {
        this.service.href('/codex');
    }

    private buildApiUrl(fn: string, params: any = {}): string {
        const base = wiz.url(fn);
        const qs = Object.entries(params).map(([k, v]: any) => `${k}=${encodeURIComponent(v)}`).join('&');
        return qs ? `${base}?${qs}` : base;
    }

    public refreshPreviewUrl() {
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.buildApiUrl('preview_studio_html', {
            notice_no: this.notice_no,
            _: Date.now(),
        }));
    }

    public async setPreviewKind(kind: 'design' | 'toc' | 'chapter' | 'empty') {
        this.previewKind = kind;
        try {
            const res = await wiz.call('set_preview_kind', { notice_no: this.notice_no, kind });
            if (res.code === 200) this.state = res.data.state || this.state;
        } catch { }
        this.refreshPreviewUrl();
        await this.service.render();
    }

    public async loadJobs(render: boolean = true) {
        try {
            const res = await wiz.call('codex_list_jobs', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.jobs = res.data.jobs || [];
                this.history = res.data.history || this.buildHistoryRows();
                if (!this.selectedJobId && this.jobs.length > 0) this.selectedJobId = this.jobs[0].id;
                const active = this.activeJob;
                if (active) this.startPolling(active.id);
            }
        } catch { }
        if (render) await this.service.render();
    }

    public get selectedJob(): any {
        if (!this.jobs.length) return null;
        return this.jobs.find((job: any) => job.id === this.selectedJobId) || this.jobs[0];
    }

    public get historyRows(): any[] {
        const source = Array.isArray(this.history) && this.history.length > 0 ? this.history : this.buildHistoryRows();
        return source || [];
    }

    public get visibleHistoryRows(): any[] {
        return this.historyRows.slice(0, 8);
    }

    public get historyStats(): any {
        const rows = this.historyRows;
        const running = rows.filter((row: any) => row.status === 'running' || row.status === 'queued').length;
        const done = rows.filter((row: any) => row.status === 'done').length;
        return {
            total: rows.length,
            running,
            done,
        };
    }

    public get selectedJobLogs(): any[] {
        const logs = Array.isArray(this.selectedJob?.logs) ? this.selectedJob.logs : [];
        return logs.slice(-8).reverse();
    }

    public get activeJob(): any {
        return this.runningJob || this.queuedJobs[0] || null;
    }

    public get runningJob(): any {
        return this.jobs.find((job: any) => job.status === 'running') || null;
    }

    public get queuedJobs(): any[] {
        return this.jobs.filter((job: any) => job.status === 'queued');
    }

    public selectJob(job: any) {
        if (!job?.id) return;
        this.selectedJobId = job.id;
        void this.refreshJob(job.id, true);
    }

    public selectHistory(row: any) {
        if (!row?.job_id) return;
        this.selectedJobId = row.job_id;
        void this.refreshJob(row.job_id, true);
    }

    public isHistoryActive(row: any): boolean {
        return !!row?.job_id && row.job_id === this.selectedJob?.id;
    }

    public get hasRunningJob(): boolean {
        return !!this.activeJob;
    }

    public get canSendRequest(): boolean {
        if (this.approvingStage) return false;
        if (this.codexLoading) return false;
        if (this.hasRunningJob && this.codexStage !== 'chapter_generate') return false;
        if (this.codexStage === 'revision' && !this.hasDownloadableOutput) return false;
        if (this.codexStage === 'chapter_generate') {
            const selectedChapter = this.chapterRows.find((row: any) => row.id === this.selectedChapterId);
            return this.canRunChapter && !this.isChapterBusy(selectedChapter);
        }
        return true;
    }

    public get sendButtonLabel(): string {
        if (this.approvingStage === 'toc') return '목차 확정 중';
        if (this.codexLoading) return '요청 전송 중';
        if (this.codexStage === 'chapter_generate' && !this.canRunAnyChapter) return '목차 확정 필요';
        if (this.codexStage === 'revision' && !this.hasDownloadableOutput) return '산출물 생성 필요';
        if (this.codexStage === 'chapter_generate') {
            const selectedChapter = this.chapterRows.find((row: any) => row.id === this.selectedChapterId);
            if (selectedChapter?.status === 'running') return '챕터 생성 중';
            if (selectedChapter?.status === 'queued') return '이미 대기 중';
        }
        if (this.hasRunningJob && this.codexStage === 'chapter_generate') return '큐에 추가';
        if (this.hasRunningJob) return 'Codex 작업 중';
        const stage = this.stages.find((item: any) => item.id === this.codexStage);
        return stage?.actionLabel || '요청 보내기';
    }

    public get hasTocDraft(): boolean {
        return !!(
            this.state?.toc_status === 'done' ||
            this.state?.toc_status === 'approved' ||
            this.state?.toc_markdown ||
            this.state?.toc_html ||
            (this.chapterRows || []).length > 0
        );
    }

    public get isTocApproved(): boolean {
        return this.state?.toc_status === 'approved' && this.hasTocDraft;
    }

    public get designGateTitle(): string {
        if (!this.hasTocDraft) return 'RFP를 먼저 목차로 구조화하세요';
        if (!this.isTocApproved) return '목차 확정 후 챕터별 생성으로 넘어갑니다';
        return '확정된 목차를 기준으로 챕터를 자유롭게 생성합니다';
    }

    public get designGateMessage(): string {
        if (!this.hasTocDraft) return '장/절, 평가 대응, 페이지 계획을 먼저 잡고 이후 챕터별 HTML을 생성합니다.';
        if (!this.isTocApproved) return '오른쪽 생성 단계에서 목차를 확정하면 챕터별 생성 단계가 열립니다.';
        return '별도 사전 스타일을 재사용하지 않고, 각 챕터 생성 시 Codex가 A4 세로 규격 안에서 자유롭게 구성합니다.';
    }

    public get canApproveToc(): boolean {
        return this.hasTocDraft && !this.isTocApproved && !this.approvingStage;
    }

    public get canRunToc(): boolean {
        return !this.codexLoading && !this.hasRunningJob;
    }

    public get canRunAnyChapter(): boolean {
        return this.isTocApproved;
    }

    public get canRunChapter(): boolean {
        return this.canRunAnyChapter && !!this.selectedChapterId;
    }

    public get chapterRows(): any[] {
        return this.state?.chapters || this.state?.chapter_plan || [];
    }

    public get selectedChapter(): any {
        return this.chapterRows.find((row: any) => row.id === this.selectedChapterId) || null;
    }

    public get selectedChapterValidationErrors(): string[] {
        const errors = this.selectedChapter?.validation_errors;
        return Array.isArray(errors) ? errors : [];
    }

    public get selectedChapterValidationWarnings(): string[] {
        const reportIssues = this.selectedChapter?.validation_report?.issues;
        if (Array.isArray(reportIssues) && reportIssues.length > 0) return reportIssues;
        const warnings = this.selectedChapter?.validation_warnings;
        return Array.isArray(warnings) ? warnings : [];
    }

    public validationErrorLabel(error: string): string {
        const map: any = {
            empty: 'HTML 내용이 비어 있거나 너무 짧습니다.',
            meta_explanation_text: '보이는 텍스트에 메타 설명 문구가 포함되어 있습니다.',
            white_on_white: '흰 배경에 흰 글씨 조합이 감지되었습니다.',
            dark_on_dark: '어두운 배경에 어두운 글씨 조합이 감지되었습니다.',
            font_too_small: '9px 이하 글자 크기가 감지되었습니다.',
            not_a4: 'A4 세로 문서가 아닌 슬라이드/16:9 형태가 감지되었습니다.',
            not_a4_width: '페이지 너비가 A4 794px 기준을 벗어났습니다.',
            page_overflow_visible: '페이지 overflow가 visible이라 footer 겹침 위험이 있습니다.',
            footer_not_absolute: '푸터가 absolute 고정 방식이 아닙니다.',
            h2_margin_too_tight: '표나 도식 다음 제목 여백이 부족합니다.',
            h2_margin_not_defined: 'h2 제목 여백 규칙이 정의되지 않았습니다.',
            visual_vertical_text: '인포그래픽에 세로 텍스트/writing-mode가 감지되었습니다.',
            visual_narrow_node: '인포그래픽에 너무 좁은 노드가 있어 글자 깨짐 위험이 있습니다.',
            visual_clip_risk: '인포그래픽에 고정 높이와 overflow hidden이 함께 있어 하단 잘림 위험이 있습니다.',
            three_consecutive_tables: '표가 3페이지 연속 배치되었습니다.',
            too_many_tables: '표 페이지 비율이 50%를 초과했습니다.',
            missing_table_page: '3컬럼 또는 4컬럼 표 페이지가 없습니다.',
            missing_kpi_page: 'KPI 카드 페이지가 없습니다.',
            missing_comparison_page: '좌우 비교 레이아웃 페이지가 없습니다.',
            missing_flow_page: '박스와 화살표 흐름 인포그래픽 페이지가 없습니다.',
            missing_diagram_page: '계층 구조 또는 레이어 다이어그램 페이지가 없습니다.',
            missing_text_page: '본문 단락 위주 페이지가 없습니다.',
            visual_diversity_low: '챕터 내 시각 자료 유형이 부족합니다.',
            content_density_low: '본문 밀도가 낮아 보강 검토가 필요합니다.',
            filler_validation_table: '자동 검증 보강표처럼 보이는 반복 표가 있습니다.',
            filler_validation_table_repeated: '검증 보강표가 반복됩니다.',
            repeated_requirement_ids: '요구사항 ID가 과도하게 반복됩니다.',
            footer_page_number_error: '푸터 또는 페이지 번호가 올바르게 렌더링되지 않았습니다.',
            not_a4_height: '페이지 높이가 A4 1123px 기준을 벗어났습니다.',
            page_overflow_actual: '본문이 페이지 안전 영역을 실제로 넘쳤습니다.',
            density_validation_table: 'density-validation-table 산출물이 포함되어 있습니다.',
            codex_flow_rebuilt: 'codex-flow-rebuilt 보정 산출물이 포함되어 있습니다.',
            empty_diagram_process_node: '도식 또는 프로세스 노드에 빈 항목이 있습니다.',
            repeated_generic_phrase: '반복 generic phrase가 과다합니다.',
            missing_layout_variant: '본문 페이지의 layout_variant가 누락되었습니다.',
            minor_caption_missing: '표/그림 캡션이 일부 누락되었습니다.',
            page_type_structure_weak: 'page_type 권장 구조가 충분하지 않습니다.',
            validation_runtime_unavailable: '렌더링 기반 검증을 완료하지 못했습니다.',
        };
        return map[error] || error;
    }

    private pageCountValue(value: any): number {
        const raw = String(value || '').trim();
        if (!raw || raw === '-') return 0;
        const compact = raw.replace(/\s+/g, '');
        const range = compact.match(/^(\d+)(?:-|~|부터|to)(\d+)(?:p|page|페이지|쪽)?$/i);
        if (range) {
            const start = Number(range[1]);
            const end = Number(range[2]);
            return end >= start ? end - start + 1 : 0;
        }
        const single = compact.match(/^(\d+)(?:p|page|페이지|쪽)?$/i);
        return single ? Number(single[1]) : 0;
    }

    public get hasGeneratedChapterOutput(): boolean {
        return !!(
            this.state?.chapters_preview_html ||
            this.chapterRows.some((chapter: any) => chapter?.html || chapter?.status === 'done')
        );
    }

    public get plannedChapterPageCount(): number {
        const statePlanned = Number(this.state?.planned_page_count || 0);
        if (statePlanned > 0) return statePlanned;
        return this.chapterRows.reduce((sum: number, chapter: any) => sum + this.pageCountValue(chapter?.pages), 0);
    }

    public get totalPageCountLabel(): string {
        const actual = Number(this.state?.total_page_count || 0);
        if (this.hasGeneratedChapterOutput && actual > 0) return `전체 ${actual}p`;
        const planned = this.plannedChapterPageCount;
        if (planned > 0) return `예상 ${planned}p`;
        if (actual > 0) return `전체 ${actual}p`;
        return '';
    }

    public chapterPageLabel(chapter: any): string {
        const raw = String(chapter?.pages || chapter?.page_count || chapter?.target_pages || chapter?.target_page_count || '').trim();
        if (!raw || raw === '-') return '';
        const compact = raw.replace(/\s+/g, '');
        if (/^\d+$/.test(compact)) return `${compact}p`;
        return compact
            .replace(/페이지|쪽/gi, 'p')
            .replace(/page/gi, 'p')
            .replace(/P/g, 'p');
    }

    public get hasDownloadableOutput(): boolean {
        return !!(
            this.state?.chapters_preview_html ||
            this.chapterRows.some((chapter: any) => chapter?.html || chapter?.status === 'done') ||
            this.hasTocDraft
        );
    }

    public get hasPendingStageApproval(): boolean {
        return !!(this.hasTocDraft && !this.isTocApproved);
    }

    public get showStarterGuide(): boolean {
        return !this.hasTocDraft && !this.chapterRows.length;
    }

    public get rfpReadyLabel(): string {
        const count = this.rfpDocs.length;
        if (count > 0) return `${count}개 RFP 연결됨`;
        return 'RFP가 필요합니다';
    }

    public get actionPanelTitle(): string {
        if (this.codexStage === 'toc_design') return '목차 설계 요청';
        if (this.codexStage === 'chapter_generate') return '챕터별 생성 요청';
        return '수정 요청';
    }

    public get actionPanelHint(): string {
        if (this.codexStage === 'toc_design') return 'RFP 원문 기준으로 장·절, 평가 대응, 페이지 계획을 정리합니다.';
        if (this.codexStage === 'chapter_generate') return '선택한 챕터를 A4 세로 규격 안에서 자유롭게 생성합니다.';
        return '현재 미리보기 산출물에서 어색한 부분을 보정합니다.';
    }

    public get stageDescription(): string {
        const stage = this.stages.find((item: any) => item.id === this.codexStage);
        return stage?.hint || '';
    }

    public rightPaneStageLabel(label: string = ''): string {
        return String(label || '');
    }

    public isStageComplete(stageId: string): boolean {
        if (stageId === 'toc_design') return this.hasTocDraft;
        if (stageId === 'chapter_generate') {
            return this.chapterRows.some((chapter: any) => chapter?.status === 'done');
        }
        return false;
    }

    public isStageApproved(stageId: string): boolean {
        if (stageId === 'toc_design') return this.isTocApproved;
        return false;
    }

    public isStageLocked(stageId: string): boolean {
        if (stageId === 'chapter_generate') return !this.canRunAnyChapter;
        if (stageId === 'revision') return !this.hasDownloadableOutput;
        return false;
    }

    public stageNumber(stage: any): string {
        const index = this.stages.findIndex((item: any) => item.id === stage?.id);
        return String(index + 1).padStart(2, '0');
    }

    public stageStateLabel(stageId: string): string {
        if (this.isStageApproved(stageId)) return '확정됨';
        if (this.isStageComplete(stageId)) return '완료';
        if (this.isStageLocked(stageId)) return '준비 필요';
        if (this.codexStage === stageId) return '선택됨';
        return '대기';
    }

    public stageButtonIcon(stage: any): string {
        if (this.isStageLocked(stage?.id)) return 'fas fa-lock';
        return (this.isStageApproved(stage?.id) || this.isStageComplete(stage?.id)) ? 'fas fa-check' : stage?.icon;
    }

    private preferredCodexStageFromState(): string {
        const savedStage = String(this.state?.stage || '').trim();
        if (this.canRunAnyChapter) return 'chapter_generate';
        if (this.hasTocDraft && !this.isTocApproved) return 'toc_design';
        if (savedStage === 'revision') return savedStage;
        return 'toc_design';
    }

    private syncCodexStageFromState(force: boolean = false) {
        const nextStage = this.preferredCodexStageFromState();
        if (!nextStage || nextStage === this.codexStage) {
            if (nextStage === 'chapter_generate') this.ensureSelectedChapter();
            return;
        }

        const savedStage = String(this.state?.stage || '').trim();
        const currentStageIsStale =
            (this.codexStage === 'toc_design' && (this.isTocApproved || savedStage === 'chapter_generate')) ||
            (this.codexStage === 'chapter_generate' && !this.canRunAnyChapter);

        if (!force && !currentStageIsStale) return;

        this.codexStage = nextStage;
        if (nextStage === 'chapter_generate') this.ensureSelectedChapter();
    }

    private ensureSelectedChapter() {
        if (!this.selectedChapterId && this.chapterRows.length > 0) {
            this.selectedChapterId = this.chapterRows[0].id;
        }
    }

    public get activeProgressPercent(): number {
        const job = this.activeJob;
        if (!job) return this.codexLoading ? 3 : 0;
        const progressValue = Number(job.progress_percent ?? job.progress?.percent ?? 0);
        const bounded = Math.min(Math.max(Number.isFinite(progressValue) ? progressValue : 0, 0), 100);
        if (job.status === 'queued') return bounded || 2;
        if (job.status === 'done') return 100;
        if (job.status === 'error' || job.status === 'cancelled') return 100;
        return bounded || 4;
    }

    public get activeProgressLabel(): string {
        const job = this.activeJob;
        if (!job) return this.codexLoading ? '요청 전송 중' : '대기 중';
        if (job.status === 'queued') return '작업 대기열에서 순서를 기다리는 중';
        const progress = job.progress || {};
        if (progress.source === 'codex_events' && Number(progress.event_count || 0) > 0) {
            const completed = Number(progress.item_completed || 0);
            const started = Number(progress.item_started || 0);
            if (started > 0) return `Codex 이벤트 기준 처리 중 · 항목 ${completed}/${started}`;
            return `Codex 이벤트 기준 처리 중 · 이벤트 ${progress.event_count}개`;
        }
        const logs = Array.isArray(job.logs) ? job.logs : [];
        if (logs.some((log: any) => log.kind === 'message')) return '응답을 미리보기 산출물로 정리하는 중';
        if (logs.some((log: any) => String(log.label || '').includes('turn.started'))) return 'RFP와 현재 산출물을 읽고 생성하는 중';
        if (job.thread_id || logs.some((log: any) => String(log.label || '').includes('thread'))) return 'Codex 세션 연결 완료';
        return 'Codex 프로세스 시작 중';
    }

    public get activeElapsedSeconds(): number {
        const job = this.activeJob;
        if (!job) return 0;
        const started = this.parseServerTime(job.status === 'queued' ? (job.queued || job.created) : (job.started || job.started_at || job.created));
        if (!Number.isFinite(started)) return 0;
        return Math.max(Math.floor((Date.now() - started) / 1000), 0);
    }

    public get activeElapsedLabel(): string {
        return this.formatElapsedClock(this.activeElapsedSeconds);
    }

    public get activeElapsedTitle(): string {
        const prefix = this.activeJob?.status === 'queued' ? '대기' : '경과';
        return `${prefix} ${this.formatElapsedText(this.activeElapsedSeconds)}`;
    }

    private parseServerTime(value: any): number {
        if (typeof value === 'number') return value > 100000000000 ? value : value * 1000;
        const raw = String(value || '').trim();
        if (!raw) return Number.NaN;
        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized);
        const parseValue = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized) && !hasTimezone ? `${normalized}Z` : normalized;
        const parsed = Date.parse(parseValue);
        if (Number.isFinite(parsed)) return parsed;
        return Date.parse(raw);
    }

    private formatElapsedClock(seconds: number): string {
        const total = Math.max(Math.floor(Number(seconds || 0)), 0);
        const hour = Math.floor(total / 3600);
        const min = Math.floor((total % 3600) / 60);
        const sec = total % 60;
        if (hour > 0) return `${this.padClock(hour)}:${this.padClock(min)}:${this.padClock(sec)}`;
        return `${min}:${this.padClock(sec)}`;
    }

    private formatElapsedText(seconds: number): string {
        const total = Math.max(Math.floor(Number(seconds || 0)), 0);
        const hour = Math.floor(total / 3600);
        const min = Math.floor((total % 3600) / 60);
        const sec = total % 60;
        if (hour > 0) return `${hour}시간 ${min}분 ${sec}초`;
        if (min > 0) return `${min}분 ${sec}초`;
        return `${sec}초`;
    }

    private padClock(value: number): string {
        return String(Math.max(Math.floor(Number(value || 0)), 0)).padStart(2, '0');
    }

    public get activeRecentLogs(): any[] {
        const job = this.activeJob;
        const logs = Array.isArray(job?.logs) ? job.logs : [];
        return logs.slice(-3).reverse();
    }

    public get defaultPrompt(): string {
        if (this.codexStage === 'toc_design') {
            return '첨부한 RFP를 분석해서 제안서 목차를 설계해줘.';
        }
        if (this.codexStage === 'chapter_generate') {
            const chapter = this.chapterRows.find((row: any) => row.id === this.selectedChapterId);
            const pageLabel = this.chapterPageLabel(chapter);
            const pageGuide = pageLabel ? ` 목표 ${pageLabel} 분량으로` : '';
            return `${chapter?.no || ''}. ${chapter?.title || '선택한 챕터'}만${pageGuide} 생성해줘. 예전 디자인을 재사용하지 말고 A4 세로 1240x1754 규격 안에서 내용에 맞는 레이아웃을 자유롭게 만들어줘.`;
        }
        return '현재 미리보기에서 어색한 부분을 수정해줘.';
    }

    public applyDefaultPrompt() {
        this.codexInput = this.defaultPrompt;
        void this.service.render();
    }

    public async setStage(stage: string) {
        this.codexStage = stage;
        if (stage === 'chapter_generate' && !this.canRunAnyChapter) {
            this.codexInput = '목차를 확정한 뒤 챕터를 생성할 수 있어.';
        } else if (stage === 'revision' && !this.hasDownloadableOutput) {
            this.codexInput = '먼저 목차 또는 챕터 산출물을 생성한 뒤 보정할 수 있어.';
        } else if (stage === 'chapter_generate' && !this.selectedChapterId && this.chapterRows.length > 0) {
            this.selectedChapterId = this.chapterRows[0].id;
            this.applyDefaultPrompt();
        } else if (!(this.codexInput || '').trim()) {
            this.applyDefaultPrompt();
        }
        await this.service.render();
    }

    public async selectChapter(chapter: any) {
        if (!chapter?.id) return;
        this.selectedChapterId = chapter.id;
        await this.service.render();
    }

    public clearSelectedPage() {
        this.selectedPage = null;
        void this.service.render();
    }

    public onFileChange(event: any) {
        const files: File[] = Array.from(event.target.files || []);
        if (event?.target) event.target.value = '';
        if (!files.length) return;
        this.codexFiles = [...this.codexFiles, ...files].slice(0, 8);
        void this.service.render();
    }

    public removeFile(index: number) {
        this.codexFiles = this.codexFiles.filter((_, i) => i !== index);
        void this.service.render();
    }

    public clearFiles() {
        this.codexFiles = [];
        void this.service.render();
    }

    public async startCodexRequest() {
        const message = (this.codexInput || '').trim() || this.defaultPrompt;
        if (!message || this.codexLoading) return;
        if (this.hasRunningJob && this.codexStage !== 'chapter_generate') {
            await this.service.modal.show({ title: '작업 진행 중', message: '현재 Codex 작업이 끝난 뒤 다음 요청을 보낼 수 있습니다.', cancel: false, action: '확인' });
            return;
        }
        if (this.isApprovalMessage(message)) {
            if (this.state?.toc_status === 'done') {
                await this.approve('toc');
                this.codexInput = '';
                return;
            }
        }
        if (this.codexStage === 'chapter_generate' && !this.canRunChapter) {
            await this.service.modal.show({ title: '챕터 생성 준비 필요', message: '목차를 확정한 뒤 생성할 챕터를 선택하세요.', cancel: false, action: '확인' });
            return;
        }
        const selectedChapter = this.chapterRows.find((row: any) => row.id === this.selectedChapterId);
        if (this.codexStage === 'chapter_generate' && this.isChapterBusy(selectedChapter)) {
            await this.service.modal.show({ title: '이미 대기 중', message: '선택한 챕터는 이미 생성 대기 또는 진행 중입니다.', cancel: false, action: '확인' });
            return;
        }

        this.codexLoading = true;
        this.errorMessage = '';
        this.startProgressTimer();
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('notice_no', this.notice_no);
            formData.append('message', message);
            formData.append('workflow_stage', this.codexStage);
            const requestChapterId = this.codexStage === 'chapter_generate'
                ? (this.selectedChapterId || '')
                : (this.selectedPage?.chapterId || this.selectedChapterId || '');
            formData.append('chapter_id', requestChapterId);
            formData.append('codex_model', this.codexModel || '');
            formData.append('page_id', this.selectedPage?.pageId || '');
            formData.append('page_no', this.selectedPage?.pageNo || '');
            formData.append('page_kind', this.selectedPage?.pageKind || '');
            for (const file of this.codexFiles) formData.append('file', file);

            const response = await fetch(wiz.url('codex_start'), {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const rawText = await response.text();
            let result: any = null;
            try {
                result = rawText ? JSON.parse(rawText) : null;
            } catch {
                result = null;
            }
            if (result?.code === 200 && result.data?.job) {
                this.codexInput = '';
                this.codexFiles = [];
                this.selectedJobId = result.data.job.id;
                await this.load(false);
                this.startPolling((this.runningJob || this.activeJob || result.data.job).id);
            } else {
                this.errorMessage = result?.data?.message || result?.message || this.extractErrorMessage(rawText) || `Codex 작업을 시작하지 못했습니다. (${response.status})`;
            }
        } catch (e: any) {
            this.errorMessage = e?.message || 'Codex 작업을 시작하지 못했습니다.';
        }

        this.codexLoading = false;
        await this.service.render();
    }

    private extractErrorMessage(rawText: string): string {
        if (!rawText) return '';
        try {
            const payload = JSON.parse(rawText);
            const data = payload?.data || {};
            const message = data?.message || data?.error || payload?.message || payload?.error;
            if (message) return String(message).trim().slice(0, 260);
        } catch { }
        return rawText
            .replace(/<style[\s\S]*?<\/style>/gi, ' ')
            .replace(/<script[\s\S]*?<\/script>/gi, ' ')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 260);
    }

    private parseJsonResponse(rawText: string): any {
        if (!rawText) return null;
        try {
            return JSON.parse(rawText);
        } catch {
            return null;
        }
    }

    private validationIssueText(issue: any): string {
        const page = issue?.page ? `p.${issue.page}` : '문서 전체';
        const message = issue?.message || this.validationErrorLabel(issue?.issue || '') || issue?.issue || '검증 이슈';
        const fixHint = issue?.fix_hint ? `수정: ${issue.fix_hint}` : '';
        return [ `${page} · ${message}`, fixHint ].filter(Boolean).join('\n');
    }

    private validationReportMessage(report: any): string {
        const issues = Array.isArray(report?.issues) ? report.issues : [];
        if (issues.length === 0) return report?.blocking ? '검증 ERROR로 다운로드가 차단되었습니다.' : '검증 경고가 있습니다.';
        const visible = issues.slice(0, 8).map((issue: any) => this.validationIssueText(issue));
        const hiddenCount = Math.max(0, issues.length - visible.length);
        const summary = report?.summary
            ? `ERROR ${report.summary.error_count || 0}건, WARN ${report.summary.warning_count || 0}건`
            : '';
        const tail = hiddenCount > 0 ? `외 ${hiddenCount}건은 응답 리포트에서 확인하세요.` : '';
        return [summary, ...visible, tail].filter(Boolean).join('\n\n');
    }

    private validationReportFromPayload(payload: any): any {
        return payload?.data?.report || payload?.report || null;
    }

    private async checkStudioExportGate(format: 'pdf' | 'html' | 'css' | 'zip'): Promise<boolean> {
        const response = await fetch(this.buildApiUrl('validate_studio_export', {
            notice_no: this.notice_no,
            format,
            _: Date.now(),
        }), {
            method: 'GET',
            credentials: 'same-origin',
        });
        const rawText = await response.text();
        const payload = this.parseJsonResponse(rawText);
        const report = this.validationReportFromPayload(payload);
        const blocked = !!(payload?.data?.blocked || report?.blocking);

        if (!response.ok || blocked) {
            await this.service.modal.show({
                title: '산출물 다운로드 차단',
                message: report ? this.validationReportMessage(report) : (this.extractErrorMessage(rawText) || '검증 ERROR로 다운로드가 차단되었습니다.'),
                cancel: false,
                action: '확인',
                status: 'error',
                actionBtn: 'error',
            });
            return false;
        }

        const issues = Array.isArray(report?.issues) ? report.issues : [];
        if (issues.length > 0) {
            await this.service.modal.show({
                title: '산출물 검증 경고',
                message: this.validationReportMessage(report),
                cancel: false,
                action: '확인 후 다운로드',
                status: 'warning',
                actionBtn: 'warning',
            });
        }
        return true;
    }

    private downloadErrorFromText(rawText: string, status: number): any {
        const payload = this.parseJsonResponse(rawText);
        const report = this.validationReportFromPayload(payload);
        const message = report
            ? this.validationReportMessage(report)
            : (this.extractErrorMessage(rawText) || `다운로드 파일이 아닌 응답을 받았습니다. (${status})`);
        const error: any = new Error(message);
        if (report) error.validationReport = report;
        return error;
    }

    private sanitizeFilename(value: string): string {
        const name = String(value || '').replace(/[\\/:*?"<>|]+/g, '_').replace(/\s+/g, ' ').trim();
        return (name || 'proposal').slice(0, 90);
    }

    private downloadFilenameFromHeader(contentDisposition: string | null): string {
        const value = contentDisposition || '';
        const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(value);
        if (encoded?.[1]) {
            try {
                return decodeURIComponent(encoded[1].replace(/^["']|["']$/g, ''));
            } catch { }
        }
        const quoted = /filename\s*=\s*"([^"]+)"/i.exec(value);
        if (quoted?.[1]) return quoted[1];
        const plain = /filename\s*=\s*([^;]+)/i.exec(value);
        return plain?.[1]?.trim() || '';
    }

    public get downloadProgressLabel(): string {
        if (this.downloadingFormat === 'html') return 'HTML 생성 중';
        if (this.downloadingFormat === 'css') return 'CSS 생성 중';
        if (this.downloadingFormat === 'zip') return 'ZIP 생성 중';
        return 'PDF 생성 중';
    }

    public async toggleDownloadMenu() {
        if (this.pdfDownloading) return;
        this.downloadMenuOpen = !this.downloadMenuOpen;
        await this.service.render();
    }

    private async artifactBlobFromResponse(response: Response, format: 'pdf' | 'html' | 'css' | 'zip'): Promise<Blob> {
        const buffer = await response.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const isPdf = bytes.length >= 5 && bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46 && bytes[4] === 0x2d;
        const isZip = bytes.length >= 4 && bytes[0] === 0x50 && bytes[1] === 0x4b && bytes[2] === 0x03 && bytes[3] === 0x04;
        const hasExpectedSignature = (format === 'pdf' && isPdf) || (format === 'zip' && isZip) || format === 'html' || format === 'css';

        if (!response.ok || !hasExpectedSignature) {
            let rawText = '';
            try {
                rawText = new TextDecoder('utf-8').decode(bytes);
            } catch { }
            throw this.downloadErrorFromText(rawText, response.status);
        }

        const fallbackTypes: any = {
            pdf: 'application/pdf',
            html: 'text/html',
            css: 'text/css',
            zip: 'application/zip',
        };
        return new Blob([bytes], { type: response.headers.get('Content-Type') || fallbackTypes[format] });
    }

    public async downloadStudioArtifact(format: 'pdf' | 'html' | 'css' | 'zip') {
        if (this.pdfDownloading) return;
        if (!this.hasDownloadableOutput) {
            await this.service.modal.show({ title: '다운로드할 산출물 없음', message: '목차, 디자인 또는 챕터 산출물을 먼저 생성해 주세요.', cancel: false, action: '확인' });
            return;
        }

        this.pdfDownloading = true;
        this.downloadingFormat = format;
        this.downloadMenuOpen = false;
        await this.service.render();
        try {
            const canDownload = await this.checkStudioExportGate(format);
            if (!canDownload) return;

            const response = await fetch(this.buildApiUrl('download_studio_artifact', {
                notice_no: this.notice_no,
                format,
                _: Date.now(),
            }), {
                method: 'GET',
                credentials: 'same-origin',
            });

            const blob = await this.artifactBlobFromResponse(response, format);
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            const filename = this.downloadFilenameFromHeader(response.headers.get('Content-Disposition'))
                || `${this.sanitizeFilename(this.item?.title || this.notice_no || 'proposal')}.${format}`;
            anchor.href = objectUrl;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        } catch (e: any) {
            await this.service.modal.show({
                title: e?.validationReport?.blocking ? '산출물 다운로드 차단' : '산출물 다운로드 실패',
                message: e?.message || '산출물을 생성하지 못했습니다.',
                cancel: false,
                action: '확인',
                status: e?.validationReport?.blocking ? 'error' : 'error',
                actionBtn: 'error',
            });
        } finally {
            this.pdfDownloading = false;
            this.downloadingFormat = '';
            await this.service.render();
        }
    }

    public async downloadStudioPdf() {
        await this.downloadStudioArtifact('pdf');
    }

    private isApprovalMessage(message: string): boolean {
        const value = (message || '').replace(/\s+/g, '').toLowerCase();
        if (!value || value.length > 24) return false;
        if (/(목차|설계|생성|수정|기준|방향|챕터|본문|다이어그램|파이프라인|아키텍처)/.test(value)) return false;
        return /^(괜찮아?|좋아|좋습니다|승인|확정|이걸로|이걸로진행|진행해|진행하자|오케이|ok|okay)$/.test(value);
    }

    public async approve(stage: 'toc') {
        const label = '목차';
        if (this.approvingStage) return;
        if (stage === 'toc' && this.isTocApproved) {
            this.codexStage = 'chapter_generate';
            this.codexInput = this.defaultPrompt;
            await this.service.render();
            return;
        }
        if (stage === 'toc' && !this.hasTocDraft) {
            await this.service.modal.show({ title: '목차 초안 없음', message: '확정할 목차 설계를 먼저 생성해 주세요.', cancel: false, action: '확인' });
            return;
        }
        const ok = true;
        if (!ok) return;

        this.approvingStage = stage;
        this.errorMessage = '';
        await this.service.render();
        try {
            const res = await wiz.call('approve_stage', { notice_no: this.notice_no, stage });
            if (res.code === 200) {
                this.state = res.data.state || this.state;
                this.previewKind = this.state.preview_kind || this.previewKind;
                this.syncCodexStageFromState(true);
                this.codexInput = this.defaultPrompt;
                this.refreshPreviewUrl();
                await this.load(false);
            } else {
                const message = res.data?.message || res.message || `${label} 확정에 실패했습니다.`;
                this.errorMessage = message;
                await this.service.modal.show({ title: `${label} 확정 실패`, message, cancel: false, action: '확인' });
            }
        } catch (e: any) {
            const message = e?.message || `${label} 확정에 실패했습니다.`;
            this.errorMessage = message;
            await this.service.modal.show({ title: `${label} 확정 실패`, message, cancel: false, action: '확인' });
        } finally {
            this.approvingStage = '';
            await this.service.render();
        }
    }

    public async generateTocDesign() {
        this.codexStage = 'toc_design';
        this.codexInput = this.defaultPrompt;
        await this.startCodexRequest();
    }

    public async generateChapter(chapter: any) {
        if (!chapter?.id) return;
        if (!this.canRunAnyChapter) {
            await this.service.modal.show({ title: '목차 확정 필요', message: '목차를 확정해야 챕터 생성을 시작할 수 있습니다.', cancel: false, action: '확인' });
            return;
        }
        this.selectedChapterId = chapter.id;
        this.codexStage = 'chapter_generate';
        if (this.isChapterBusy(chapter)) {
            await this.service.render();
            return;
        }
        const pageLabel = this.chapterPageLabel(chapter);
        const pageGuide = pageLabel ? ` 목표 ${pageLabel} 분량으로` : '';
        this.codexInput = `${chapter.no}. ${chapter.title} 챕터만${pageGuide} 생성해줘. 예전 디자인을 재사용하지 말고 A4 세로 1240x1754 규격 안에서 내용에 맞는 레이아웃을 자유롭게 만들어줘.`;
        await this.startCodexRequest();
    }

    private startPolling(jobId: string) {
        if (!jobId) return;
        this.pollingJobId = jobId;
        if (this.pollTimer) clearInterval(this.pollTimer);
        this.pollTimer = setInterval(() => void this.refreshJob(jobId, true), 3500);
        this.startProgressTimer();
    }

    private stopPolling() {
        if (this.pollTimer) clearInterval(this.pollTimer);
        this.pollTimer = null;
        this.pollingJobId = '';
        this.stopProgressTimer();
    }

    private startProgressTimer() {
        if (this.progressTimer) clearInterval(this.progressTimer);
        this.progressTimer = setInterval(() => {
            if (!this.activeJob && !this.codexLoading) {
                this.stopProgressTimer();
                return;
            }
            void this.service.render();
        }, 1000);
    }

    private stopProgressTimer() {
        if (this.progressTimer) clearInterval(this.progressTimer);
        this.progressTimer = null;
    }

    public async refreshJob(jobId: string = '', render: boolean = true) {
        const targetId = jobId || this.selectedJob?.id || '';
        if (!targetId) return;
        try {
            const res = await wiz.call('codex_job_status', { notice_no: this.notice_no, job_id: targetId });
            if (res.code === 200 && res.data?.job) {
                const job = res.data.job;
                const idx = this.jobs.findIndex((item: any) => item.id === job.id);
                if (idx >= 0) this.jobs[idx] = job;
                else this.jobs.unshift(job);
                if (res.data.state) {
                    this.state = res.data.state;
                    this.previewKind = this.state.preview_kind || this.previewKind;
                    this.syncCodexStageFromState(false);
                }
                this.history = this.buildHistoryRows();
                if (job.status !== 'running' && job.status !== 'queued' && this.pollingJobId === job.id) {
                    this.stopPolling();
                    await this.load(false);
                    this.refreshPreviewUrl();
                }
            }
        } catch { }
        if (render) await this.service.render();
    }

    public async cancelJob(job: any) {
        if (!job?.id || (job.status !== 'running' && job.status !== 'queued')) return;
        const ok = await this.service.modal.show({
            title: 'Codex 작업 중단',
            message: '진행 중인 작업을 중단할까요?',
            action: '중단',
            actionBtn: 'error',
            status: 'error',
        });
        if (!ok) return;
        await wiz.call('codex_cancel_job', { notice_no: this.notice_no, job_id: job.id });
        await this.load();
    }

    public isChapterBusy(chapter: any): boolean {
        return chapter?.status === 'running' || chapter?.status === 'queued';
    }

    public jobStatusLabel(status: string): string {
        const map: any = { queued: '대기', running: '진행 중', done: '완료', validation_failed: '검증 실패', error: '오류', cancelled: '중단' };
        return map[status] || status || '알 수 없음';
    }

    public statusClass(status: string): string {
        if (status === 'done') return 'is-done';
        if (status === 'running' || status === 'queued') return 'is-progress';
        if (status === 'error' || status === 'cancelled' || status === 'validation_failed') return 'is-error';
        return '';
    }

    public historyIcon(row: any): string {
        const type = row?.type || '';
        const stage = row?.stage || '';
        if (type === 'approval') return 'fas fa-check';
        if (type === 'material') return 'fas fa-file-lines';
        if (stage === 'toc_design') return 'fas fa-list-ol';
        if (stage === 'chapter_generate') return 'fas fa-layer-group';
        if (stage === 'revision') return 'fas fa-pen-to-square';
        return 'fas fa-clock-rotate-left';
    }

    public historyTime(row: any): string {
        return row?.time || row?.updated || row?.created || '';
    }

    public usageSummary(job: any): string {
        const usage = job?.usage || {};
        const input = Number(usage.input_tokens || 0);
        const output = Number(usage.output_tokens || 0);
        if (!input && !output && !job?.usage_credit_estimate) return '';
        const tokens = input + output;
        const parts = [];
        if (tokens > 0) parts.push(`토큰 ${this.formatNumber(tokens)}`);
        const credits = Number(job?.usage_credit_estimate || 0);
        if (Number.isFinite(credits) && credits > 0) parts.push(`${credits.toFixed(2)} credits`);
        return parts.join(' · ');
    }

    public formatNumber(value: number = 0): string {
        const number = Number(value || 0);
        if (!Number.isFinite(number)) return '0';
        return number.toLocaleString('ko-KR');
    }

    private compactText(value: string = '', limit: number = 160): string {
        const text = String(value || '').replace(/\s+/g, ' ').trim();
        if (text.length <= limit) return text;
        return `${text.slice(0, limit - 1).trim()}…`;
    }

    private jobHistoryMeta(job: any): string {
        const parts: string[] = [];
        const logs = Array.isArray(job?.logs) ? job.logs : [];
        const progress = job?.progress || {};
        const usage = job?.usage || {};
        if (logs.length > 0) parts.push(`로그 ${logs.length}개`);
        if (Number(progress.event_count || 0) > 0) parts.push(`이벤트 ${progress.event_count}개`);
        const tokenTotal = Number(usage.input_tokens || 0) + Number(usage.output_tokens || 0);
        if (tokenTotal > 0) parts.push(`토큰 ${this.formatNumber(tokenTotal)}`);
        const credits = Number(job?.usage_credit_estimate || 0);
        if (Number.isFinite(credits) && credits > 0) parts.push(`${credits.toFixed(2)} credits`);
        return parts.join(' · ');
    }

    private buildHistoryRows(): any[] {
        const rows: any[] = [];
        const jobMap: any = {};
        for (const job of this.jobs || []) {
            if (job?.id) jobMap[job.id] = job;
            const logs = Array.isArray(job?.logs) ? job.logs : [];
            const latestLog = logs.length > 0 ? logs[logs.length - 1] : null;
            rows.push({
                id: `job:${job?.id || ''}`,
                type: 'job',
                job_id: job?.id || '',
                stage: job?.workflow_stage || '',
                title: job?.workflow_stage_label || 'Codex 작업',
                status: job?.status || '',
                message: this.compactText(job?.message || job?.final_response || latestLog?.text || '', 180),
                meta: this.jobHistoryMeta(job),
                time: job?.finished || job?.updated || job?.created || '',
                created: job?.created || '',
                updated: job?.updated || '',
                progress_percent: Number(job?.progress_percent || job?.progress?.percent || 0),
                log_count: logs.length,
                latest_log: latestLog?.text || '',
                harness_verdict: job?.harness_verdict || '',
            });
        }

        const jobTime = (jobId: string) => {
            const job = jobMap[jobId || ''];
            return job ? (job.finished || job.updated || job.created || '') : '';
        };
        const chapters = this.chapterRows || [];
        const tocJobId = this.state?.approved_toc_job_id || this.state?.latest_toc_job_id || '';
        if (this.state?.toc_status === 'approved') {
            rows.push({
                id: 'state:toc_approved',
                type: 'approval',
                job_id: tocJobId,
                stage: 'toc_design',
                title: '목차 확정',
                status: 'done',
                message: '생성된 목차가 챕터 계획으로 반영되었습니다.',
                meta: `챕터 ${chapters.length || 0}개`,
                time: this.state?.approved_toc_at || jobTime(tocJobId) || this.state?.updated || '',
                progress_percent: 100,
            });
        } else if (this.state?.toc_status === 'done') {
            const latestTocJobId = this.state?.latest_toc_job_id || '';
            rows.push({
                id: 'state:toc_done',
                type: 'artifact',
                job_id: latestTocJobId,
                stage: 'toc_design',
                title: '목차 초안 반영',
                status: 'done',
                message: '목차 미리보기와 챕터 계획이 생성되었습니다.',
                meta: `챕터 ${chapters.length || 0}개`,
                time: jobTime(latestTocJobId) || this.state?.updated || '',
                progress_percent: 100,
            });
        }

        if ((this.docs || []).length > 0) {
            let latestDocTime = '';
            for (const doc of this.docs || []) {
                latestDocTime = [latestDocTime, doc?.created || doc?.updated || ''].sort().pop() || latestDocTime;
            }
            rows.push({
                id: 'docs:rfp',
                type: 'material',
                job_id: '',
                stage: 'material',
                title: 'RFP / 첨부 반영',
                status: 'done',
                message: `첨부 파일 ${(this.docs || []).length}개가 현재 Codex 컨텍스트에 연결되어 있습니다.`,
                meta: '',
                time: latestDocTime || this.state?.created || this.state?.updated || '',
                progress_percent: 100,
            });
        }

        return rows.sort((a: any, b: any) => String(b.time || b.created || '').localeCompare(String(a.time || a.created || '')));
    }

    public formatSize(size: number = 0): string {
        if (!Number.isFinite(size) || size <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let value = size;
        let idx = 0;
        while (value >= 1024 && idx < units.length - 1) {
            value = value / 1024;
            idx += 1;
        }
        return `${value.toFixed(idx === 0 || value >= 10 ? 0 : 1)} ${units[idx]}`;
    }

    public openDocument(doc: any) {
        if (!doc?.id) return;
        window.open(this.buildApiUrl('download_rfp_document', { doc_id: doc.id, _: Date.now() }), '_blank');
    }
}

export default PageCodexDetailComponent;